import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-rejection-confirmation-dialog',
  templateUrl: './rejection-confirmation-dialog.component.html',
  styleUrls: ['./rejection-confirmation-dialog.component.css']
})
export class RejectionConfirmationDialogComponent implements OnInit {
  public rejectionComments: string = '';
  public showerror: boolean;
  constructor(public dialogref: MatDialogRef<RejectionConfirmationDialogComponent>,
    public dialog: MatDialog) { }

  ngOnInit() {
  }
  
  /**function to show nd hide reject dialog popup */
  rejectClicked() {
    if (this.rejectionComments == '') {
      this.showerror = true;
    }
    else {
      this.dialogref.close(true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/rejection-confirmation-dialog/rejection-confirmation-dialog.component.ts